import { render, staticRenderFns } from "./explainer-landing-page.vue?vue&type=template&id=700b8260&scoped=true&"
import script from "./explainer-landing-page.vue?vue&type=script&lang=js&"
export * from "./explainer-landing-page.vue?vue&type=script&lang=js&"
import style0 from "./explainer-landing-page.vue?vue&type=style&index=0&id=700b8260&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700b8260",
  null
  
)

export default component.exports